import {
    setCookie,
    getCookie,
    initializeMap,
    initMenuTrigger,
    initOpenInNewTab,
    aosConfig,
    addScollClass,
    addFancyboxFixForGallery,
    initGallerySlider,
    addCloseCookies,
    initForm,
    googleMapInit,
    initLoadNews,
    faqService
} from './functions';


//import gsap from "gsap";


const mainApp = () => {



    // init menu trigger
    initMenuTrigger();

    // init open in new tab
    initOpenInNewTab();



    // add scroll class to body  
    addScollClass('0px', 'scroll');



    //fix gallery id for slideshow
    addFancyboxFixForGallery('.wp-block-gallery');

    //gallerySlider
    initGallerySlider();

    // add close function to cookies
    addCloseCookies();



    //start - contact form
    initForm();

    googleMapInit();


    initLoadNews();

    faqService();


}

document.addEventListener("DOMContentLoaded", mainApp, false);

function gRound(value, decimals) {
    return Number(Math.round(value + 'e' + decimals) + 'e-' + decimals);
}

const formatter = new Intl.NumberFormat('pl-PL', {
    style: 'currency',
    currency: 'PLN',
    minimumFractionDigits: 0,
});
var gCalcRenderTimer;
var gCalcRenderContent = document.querySelector('.gCalc__results');
if (gCalcRenderContent)
    gCalcRenderContent = gCalcRenderContent.innerHTML;
var gCalcNonPrice = ['calc_iowwsr', 'calc_zrnto', 'calc_izool', 'calc_zepkwhg', 'calc_kriwp7l', 'calc_sitowori'];

const gCalcRender = () => {

    gCalcValues.calc_lknu = parseFloat(gCalcValues.calc_iowwsr) * parseFloat(gCalcValues.calc_apknu1to);

    gCalcValues.calc_spnnto = parseFloat(gCalcValues.calc_rcns1tno) + parseFloat(gCalcValues.calc_apknu1to);

    gCalcValues.calc_knwpn1to = Math.round(parseFloat(gCalcValues.calc_csn1tr) * 0.2);

    gCalcValues.calc_kopl = parseFloat(gCalcValues.calc_z1onr) * parseFloat(gCalcValues.calc_izool);
    gCalcValues.calc_kowpn1to = parseFloat(gCalcValues.calc_kopl) / parseFloat(gCalcValues.calc_iowwsr);
    gCalcValues.calc_kcento = (parseFloat(gCalcValues.calc_zepkwhg) / 4.5) * parseFloat(gCalcValues.calc_zekren);

    gCalcValues.calc_skonto = parseFloat(gCalcValues.calc_kowpn1to) +
        parseFloat(gCalcValues.calc_kcento) +
        parseFloat(gCalcValues.calc_kozlt) +
        parseFloat(gCalcValues.calc_olzut) +
        parseFloat(gCalcValues.calc_knwpn1to);

    gCalcValues.calc_sitowori = parseFloat(gCalcValues.calc_iowwsr) * parseFloat(gCalcValues.calc_kriwp7l);

    gCalcValues.calc_kint = parseFloat(gCalcValues.calc_knzkif) / parseFloat(gCalcValues.calc_sitowori);

    gCalcValues.calc_lkoiinto = parseFloat(gCalcValues.calc_kint) + parseFloat(gCalcValues.calc_skonto);

    gCalcValues.calc_lp = (parseFloat(gCalcValues.calc_apknu1to) + parseFloat(gCalcValues.calc_rcns1tno))
        * parseFloat(gCalcValues.calc_iowwsr);

    gCalcValues.calc_lko = parseFloat(gCalcValues.calc_iowwsr) * parseFloat(gCalcValues.calc_lkoiinto);


    gCalcValues.calc_drz = parseFloat(gCalcValues.calc_lp) - parseFloat(gCalcValues.calc_lko);

    gCalcValues.calc_dzntspo = parseFloat(gCalcValues.calc_drz) / parseFloat(gCalcValues.calc_iowwsr);



    clearTimeout(gCalcRenderTimer);
    gCalcRenderTimer = window.setTimeout(() => {
        let content = document.querySelector('.gCalc__results');
        if (gCalcRenderContent && gCalcValues) {
            let temp = gCalcRenderContent;
            for (let item in gCalcValues) {
                temp = temp.replaceAll(
                    '{{' + item + '}}',
                    gCalcNonPrice.includes(item) ? parseFloat(gCalcValues[item]) : formatter.format(parseFloat(gCalcValues[item]))
                );
            }
            content.innerHTML = temp;
        }
    }, 200);
}
function rangeSlider(id) {

    var range = document.getElementById(id);

    var dragger = range.children[0],
        draggerWidth = 0,
        down = false,
        bg = range.children[1],
        rangeWidth, rangeLeft;

    var initPercent = Math.round(((parseFloat(dragger.dataset.val) - parseFloat(dragger.dataset.min)) / (parseFloat(dragger.dataset.max) - parseFloat(dragger.dataset.min))) * 100) + '%';
    dragger.style.left = initPercent;
    bg.style.width = initPercent;



    // zcfgb
    range.addEventListener("mousedown", startDrag);

    document.addEventListener("mousemove", function (e) {
        updateDragger(e);
    });

    document.addEventListener("mouseup", function () {
        down = false;
    });

    range.addEventListener("touchstart", startDrag);

    document.addEventListener("touchmove", function (e) {
        updateDragger(e);

    }, false);

    document.addEventListener("touchend", function () {
        down = false;
    });

    function startDrag(e) {
        rangeWidth = this.offsetWidth;
        rangeLeft = range.getBoundingClientRect().left;
        down = true;
        updateDragger(e);
        return false;
    }

    function updateDragger(e) {
        let currentX;
        if (e.type === "touchmove") {
            currentX = e.touches[0].clientX;
        } else {
            currentX = e.pageX;
        }
        if (down && currentX >= rangeLeft && currentX <= (rangeLeft + rangeWidth)) {
            dragger.style.left = currentX - rangeLeft - draggerWidth + 'px';
            if (typeof onDrag == "function") onDrag(
                ((currentX - rangeLeft) / rangeWidth) * 100
            );
        }
    }

    function onDrag(p) {

        bg.style.width = p + '%';
        let val = parseFloat(dragger.dataset.min) + Math.round((Math.round(p) * (dragger.dataset.max - dragger.dataset.min) / 100));
        if (val <= 0) val = 1;
        dragger.dataset.val = val;

        calc(val);


    }


    function calc(val) {
        range.querySelector(':scope input').value = val;
        const idTab = {
            'calcSlider3': 'calc_iowwsr',
            'calcSlider4': 'calc_apknu1to',
            'calcSlider5': 'calc_rcns1tno',
            'calcSlider6': 'calc_knzkif',
        }
        gCalcValues[idTab[id]] = val;
        gCalcRender();

    }
    calc(dragger.dataset.val);
}

(function ($) {
    const mainAppWithJquery = () => {

        const gCalc = document.querySelector('.gCalc');
        if (gCalc) {
            const gCalcChangeStep = (className) => {
                const cn = ['calcStep1', 'calcStep2', 'calcStep3'];
                cn.forEach(element => {
                    if (element == className)
                        document.body.classList.add(element);
                    else
                        document.body.classList.remove(element);
                });
            };

            const gCalcSendCode = () => {
                const formData = new FormData();
                formData.append('action', 'sendcode');
                formData.append('query', ajaxParams.posts);
                formData.append('code', document.querySelector('input[name="formCalcCode"]').value);
                fetch(ajaxParams.ajaxurl, {
                    method: "post",
                    body: formData
                })
                    .then(res => res.text())
                    .then(res => {
                        res = JSON.parse(res);
                        if (res.status == 'ok') {
                            document.querySelector('.gCalc__form2Alert').classList.remove('show');
                            gCalcChangeStep('calcStep3');
                        } else {
                            document.querySelector('.gCalc__form2Alert').classList.add('show');
                        }

                    });
            };
            for (let ic = 3; ic < 7; ic++) {
                if (document.getElementById('calcSlider' + ic)) {
                    rangeSlider('calcSlider' + ic);
                }
            }

            var wpcf7Elm = document.querySelectorAll('.wpcf7');
            if (wpcf7Elm) {
                wpcf7Elm.forEach(wpcf7ElmItem => {
                    wpcf7ElmItem.addEventListener('wpcf7mailsent', function (event) {
                        if (event.detail.apiResponse.calculator_code != '') {
                            console.log(event.detail.apiResponse.calculator_code);
                            gCalcChangeStep('calcStep2');
                        }

                    }, false);
                });

            }



            if (getCookie('calculator_code')) {
                gCalcChangeStep('calcStep3');
            } else {
                gCalcChangeStep('calcStep1');
            }
            $('.contactform__goToCodeForm').click(function () {
                gCalcChangeStep('calcStep2');
            })
            $('.gCalc__form2Back').click(function () {
                gCalcChangeStep('calcStep1');
            })


            $('.gCalc__form2Send').click(function () {
                gCalcSendCode();
            });
            $('input[name="formCalcCode"]').keypress(function (e) {
                if (e.keyCode === 13) {
                    gCalcSendCode();
                }
            });




        }




        $('.mainHeader__searchTrigger').click(function () {
            document.querySelector('.mainHeader__search').classList.toggle('show');
            document.querySelector('.mainHeader__searchTrigger').classList.toggle('show');
        });

        let counterHolder = document.querySelector('.indexC1__counter');
        if (counterHolder) {
            // 144 s * 350 000 ton = 50 400 000
            // start date timestamp -> 1595658137
            const startDate = 1595658137;
            let nowDate = Math.floor(Date.now() / 1000) - startDate;
            let counterA = [...Math.floor(nowDate / 144).toString()];
            const initCounter = () => {
                counterHolder.innerHTML = '';
                counterA.forEach((num, index) => {
                    const numHolder = document.createElement('div');
                    numHolder.classList.add('indexC1__counterItem');
                    numHolder.classList.add('ci_' + index);
                    numHolder.dataset.val = num;
                    numHolder.dataset.nextVal = num;
                    counterHolder.append(numHolder);
                });
            };
            initCounter();

            window.setInterval(() => {
                let counterB = [...Math.floor((Math.floor(Date.now() / 1000) - startDate) / 144).toString()];
                if (counterA.length < counterB.length) {
                    counterA = counterB;
                    initCounter();
                    return;
                }
                counterB.forEach((num, index) => {
                    if (counterA[index] !== counterB[index]) {
                        let itemToChange = document.querySelector('.indexC1__counterItem.ci_' + index);
                        itemToChange.dataset.nextVal = num;
                        itemToChange.classList.add('slide');
                        window.setTimeout(() => {
                            itemToChange.dataset.val = num;
                            itemToChange.classList.remove('slide');
                        }, 1000);
                    }
                });
                counterA = counterB;
            }, 10000);
        }

        $('.subpageHeader__goDown').click(function () {
            $('html,body').animate({ 'scrollTop': ($(this).offset().top - 50) + 'px' }, 500);
        });

        $('.footer__up').click(function () {
            $('html,body').animate({ 'scrollTop': '0px' }, 500);
        });




        //rotator and sliders
        if ($('.rotatorTop').length > 0) {
            $('.rotatorTop').slick({
                infinite: true,
                arrows: true,
                dots: false,
                autoplay: true,
                slidesToShow: 1,
                slidesToScroll: 1,
                speed: 500,
                autoplaySpeed: 5000,
                fade: true,
                cssEase: 'linear'
            });
            var currentRotSlide = 0;
            $('.rotatorTop').on('beforeChange', function (event, slick, currentSlide, nextSlide) {
                currentRotSlide = currentSlide;
                $('.rotatorTop .rotator__slide:nth-child(' + (currentSlide + 1) + ')').addClass('slick-out');
            });
            $('.rotatorTop').on('afterChange', function (event, slick, currentSlide, nextSlide) {
                $('.rotatorTop .rotator__slide:nth-child(' + (currentRotSlide + 1) + ')').removeClass('slick-out');
            });
        }

        if ($('.indexC5__slider').length > 0) {
            if (!!window.IntersectionObserver) {
                let sliderObserver = new IntersectionObserver(entries => {
                    if (entries[0].isIntersecting) {
                        // console.log('slider start');
                        $('.indexC5__slider').slick({
                            infinite: true,
                            arrows: true,
                            dots: false,
                            autoplay: true,
                            slidesToShow: 3,
                            slidesToScroll: 1,
                            speed: 500,
                            autoplaySpeed: 10000,
                            variableWidth: true
                        });
                        sliderObserver.unobserve(entries[0].target);
                    }
                }, {
                    rootMargin: '300px',
                });
                const trigger = document.querySelector('.indexC5__slider');
                if (trigger) sliderObserver.observe(trigger);


            }
        }

        /*  if ($('.indexC5__slider').length > 0) {
              $('.indexC5__slider').slick({
                  infinite: true,
                  arrows: true,
                  dots: false,
                  autoplay: true,
                  slidesToShow: 3,
                  slidesToScroll: 1,
                  speed: 500,
                  autoplaySpeed: 10000,
                  variableWidth: true
              });
  
  
          }*/


        if ($('.gSlider__slider').length > 0) {
            if (!!window.IntersectionObserver) {
                let sliderObserver2 = new IntersectionObserver(entries => {
                    if (entries[0].isIntersecting) {
                        // console.log('slider start ff'); 
                        $('.gSlider__slider').slick({
                            infinite: false,
                            arrows: true,
                            dots: false,
                            autoplay: false,
                            slidesToShow: 3,
                            slidesToScroll: 1,
                            speed: 500,
                            autoplaySpeed: 10000,
                            responsive: [
                                {
                                    breakpoint: 1024,
                                    settings: {
                                        slidesToShow: 2
                                    }
                                },
                                {
                                    breakpoint: 768,
                                    settings: {
                                        slidesToShow: 1,
                                        centerMode: false
                                    }
                                },

                            ]
                        });
                        sliderObserver2.unobserve(entries[0].target);
                    }
                }, {
                    rootMargin: '300px',
                });
                const trigger2 = document.querySelector('.gSlider__slider');
                if (trigger2) sliderObserver2.observe(trigger2);


            }
        }
        /* if ($('.gSlider__slider').length > 0) {
             $('.gSlider__slider').slick({
                 infinite: false,
                 arrows: true,
                 dots: false,
                 autoplay: false,
                 slidesToShow: 3,
                 slidesToScroll: 1,
                 speed: 500,
                 autoplaySpeed: 10000,
                 responsive: [
                     {
                         breakpoint: 1024,
                         settings: {
                             slidesToShow: 2
                         }
                     },
                     {
                         breakpoint: 768,
                         settings: {
                             slidesToShow: 1,
                             centerMode: false
                         }
                     },
 
                 ]
             });
 
         }*/


        // init AOS animation config
        aosConfig();

        //fancybox
        const fcbChck = document.querySelectorAll(".blocks-gallery-item a, .fancybox, .wp-block-image a[href$='.jpg'], .wp-block-image a[href$='.jpeg'], .wp-block-image a[href$='.png']");

        if (fcbChck.length > 0) {
            let scriptF = document.createElement("script");
            scriptF.setAttribute("src", window.location.origin + "/wp-content/themes/evergreen/plugins/fancybox/jquery.fancybox.min.js");
            document.body.appendChild(scriptF);
            let cssF = document.createElement("link");
            cssF.setAttribute("rel", 'stylesheet');
            cssF.setAttribute("href", window.location.origin + "/wp-content/themes/evergreen/plugins/fancybox/jquery.fancybox.min.css");
            document.body.appendChild(cssF);

            scriptF.addEventListener("load", () => {

                $(".blocks-gallery-item a, .fancybox, .wp-block-image a[href$='.jpg'], .wp-block-image a[href$='.jpeg'], .wp-block-image a[href$='.png']").fancybox({
                    'loop': true,
                    'margin': [44, 0],
                    'gutter': 50,
                    'keyboard': true,
                    'arrows': true,
                    'infobar': false,
                    'toolbar': true,
                    'buttons': ["slideShow", "fullScreen", "close"],
                    'idleTime': 4,
                    'protect': false,
                    'modal': false,
                    'animationEffect': "fade",
                    'animationDuration': 600,
                    'transitionEffect': "fade",
                    'transitionDuration': 800,
                    backFocus: false,
                    thumbs: {
                        autoStart: true, // Display thumbnails on opening
                        hideOnClose: true, // Hide thumbnail grid when closing animation starts
                        parentEl: ".fancybox-container", // Container is injected into this element
                        axis: "y" // Vertical (y) or horizontal (x) scrolling
                    }
                });
            });

        }


        $('body *[href*="*!*"]').each(function () {
            $(this).attr('href', $(this).attr('href').replace('*!*', '@'));
        });

        $('body').find(":contains('*!*'):not(:has(*))").each(function () {
            $(this).html($(this).html().replace(/\*!\*/gim, '@'));
        });



    };
    document.addEventListener("DOMContentLoaded", mainAppWithJquery, false);

})(jQuery);



